<template>
    <div class="l-main bg-white">
        <div class="l-main-content container-xl bg-white-shadow" style="max-width: 1480px;">
            <div class="row">
                <div class="col-6">
                    <div class="input inline">
                        <input name="dates" placeholder="Choose date" />
                    </div>
                </div>
                <div class="col-6 text-right">
                    <div class="input inline">
                        <input v-on:keyup.enter="searchRecord" type="text" placeholder="Search..." v-model="search_match">
                    </div>
                </div>
            </div>
    
            <div class="row">
                <loader v-show='loading' />
    
                <vuetable v-show='!loading' class="table table-bordered table-striped" ref="vuetable" :http-options="httpOptions" :api-url="url" :fields="columns" :css="css.table" :sort-order="sortOrder" track-by="paybill" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationData"
                    @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                </vuetable>
            </div>
            <div class="vuetable-pagination row" v-show='!loading'>
                <div class="col text-left">
                    <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
                </div>
                <div class="col">
                    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage">
                    </vuetable-pagination>
                </div>
            </div>
    
        </div>
    </div>
</template>

<style lang="scss" scoped>
.ui.fixed.table {
    table-layout: auto !important;
}

td {
    white-space: nowrap;
    &.vuetable-slot {
        overflow: visible !important;
    }
}
</style>

<script>
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import loader from "@/components/loader"
import tableCss from "@/components/css.js";

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        loader
    },
    name: 'approvals',

    data() {
        return {
            url: "https://interactiveapi.chezagame.com/portal/v1/view/transactions",
            httpOptions: {
                headers: {
                    'X-App-Key': '09lib74145Qb3HO6eQTIfsbylRkyuZFT',
                    'X-Authorization-Key': 'ADMIN_APP',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-Token-Key': this.$cookies.get("accessToken")
                }
            },
            css: tableCss,
            loading: true,
            selected_data: {},
            columns: [

                {
                    name: 'mobile_number',
                    title: 'Phone',
                    sortField: 'mobile_number',
                    titleClass: '',
                    dataClass: '',

                },
                {
                    name: "transaction_date",
                    title: 'Date',
                    sortField: 'transaction_date',
                    callback: 'createdAt'
                },
                {
                    name: "amount",
                    title: 'Amount',
                    sortField: 'amount',
                },
                 {
                    name: "balance",
                    title: 'Balance',
                    sortField: 'balance',
                },
                {
                    name: 'source',
                    title: 'Source',
                    sortField: 'source',
                    titleClass: 'center aligned',
                    dataClass: 'center aligned'

                },
                {
                    name: 'transaction_type',
                    title: 'Type',
                    sortField: 'transaction_type',
                    titleClass: '',
                    dataClass: ''

                },
                {
                    name: 'reference_name',
                    title: 'Reference',
                    sortField: 'reference_name',
                    titleClass: '',
                    dataClass: ''
                },
                {
                    name: "transaction_reference_id",
                    title: 'Reference ID',
                    sortField: 'transaction_reference_id',
                },
                {
                    name: "narration",
                    title: 'Narration',
                    sortField: 'narration',
                },

            ],
            range: '',
            search_match: '',
            loadOnStart: true,
            sortOrder: [{
                field: 'transaction_date',
                direction: 'desc'
            }],
            is_partial_resulting: false,

            moreParams: {
                start: '',
                filter: '',
                end: ''
            },

        }
    },


    mounted() {
        //var headerHeight = document.getElementById('header').offsetHeight;
        //document.getElementById('main-content').style.top = headerHeight + 'px';

        var vm = this;

        var start = moment();
        var end = moment();

        function cb(start, end) {
            vm.dateFilter(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
            $('input[name="dates"]').val(start.format('D MMMM, YYYY') + ' - ' + end.format('D MMMM, YYYY'));
        }

        $('input[name="dates"]').daterangepicker({
            startDate: start,
            endDate: end,
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        }, cb);

        cb(start, end);

    },




    watch: {
        data(newVal, oldVal) {
            this.$refs.vuetable.refresh();
        },
        range() {

            var start = this.range[0];
            var end = this.range[1];
            start = moment(start).format('YYYY-MM-DD');
            end = moment(end).format('YYYY-MM-DD');
            this.moreParams.start = start;
            this.moreParams.end = end;
            this.$refs.vuetable.refresh();
        }
    },


    methods: {


        dateFilter: function(start, end) {

            var vm = this;


            vm.start = start;
            vm.end = end;


            vm.moreParams.start = start;
            vm.moreParams.end = end;

            this.$refs.vuetable.refresh();

            console.log("start date filter", start)
            console.log("end date filter ", end)
        },
        createdAt: function(value) {
            if (!value) {
                return '-';
            } else {
                return moment(value).format('h:mm a,DD MMM YYYY');
            }

        },

        searchRecord: function() {
            this.moreParams.filter = this.search_match;
            this.$refs.vuetable.refresh();
        },

        dataManager(sortOrder, pagination) {
            if (this.data.length < 1) return;

            let local = this.data;

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );
            console.log('pagination:', pagination)
            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: _.slice(local, from, to)
            };
        },


        onPaginationData(paginationData) {
            this.$refs.paginationInfo.setPaginationData(paginationData)
            this.$refs.pagination.setPaginationData(paginationData)
        },


        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },

        onLoading() {
            this.loading = true
            console.log('loading... show your spinner here')
        },
        onLoaded() {
            this.loading = false
            console.log('loaded! .. hide your spinner here');
            $(".ui.dropdown").dropdown();
        },




    },


}
</script>